// extracted by mini-css-extract-plugin
export default {"content":"CompilerContent-module__content___OLZaL","tiptap":"CompilerContent-module__tiptap___w3DDp","content_clickable":"CompilerContent-module__content_clickable___yj63X"};